import { REDUCE_EDIT_SCOPE } from '../../constants/actions/policy';

export function reduceEditScope(payload) {
    return {
        type: REDUCE_EDIT_SCOPE,
        payload,
    };
}
